<template>
    <div class="">
        <div class="header-container">
            <div class="nav-wrapper">
                <div v-for="(item,key) in navList" :key="key" @click="handleNav(item.id)" 
                :class="activeNav==item.id?'nav-item-active':'nav-item'">
                    {{item.label}}
                    <div v-if="activeNav==item.id" class="nav-line-wrapper">
                        <div class="nav-line"></div>
                    </div>
                </div>
            </div>
            <div class="search-container">
                <div class="page-mode-input-wrapper">
                    <div class="page-mode-input">
                        <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                    </div>
                    <div class="input-btn" @click="handleSearch">
                        <i class="el-icon-search input-btn-icon"></i>
                        <span class="input-btn-label">搜索</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-container">
            <div v-for="(item,key) in tableData" :key="key" class="table-item-wrapper">
                <div class="table-content-wrapper">
                    <div class="table-content">
                        <div class="table-title-wrapper">
                            <div class="table-title">
                                {{item.title}}
                            </div>
                        </div>
                        <div class="table-brief-wrapper">
                            <div class="table-brief">
                                <div class="table-brief-item">时间：{{item.date}}</div>
                                <div class="table-brief-item">地点：{{item.place}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="table-btn-wrapper">
                        <div v-if="item.isMark" class="table-btn" @click="viewDetail(item)">查看详情</div>
                        <div v-else class="table-btn" @click="viewLive">预约</div>
                    </div>
                </div>
            </div>

            <div class="view-more-btn" @click="viewMore">查看更多</div>
        </div>

        <el-dialog title="" :show-close="true" width="542px" :visible.sync="tipsDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    预约课程请打开汇学堂APP，或关注公众号“中税网产品中心”中点击线下公开课预约后进行预约！
                </div>
                <div class="dialog-btn-wrapper">
                    <div class="dialog-btn" @click="handleMark">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            dept:'',
            token:'',
            searchVal:'',
            navList:[
                {
                    id:'0',
                    label:'全部'
                },
                {
                    id:'1',
                    label:'已预约'
                },
                {
                    id:'2',
                    label:'未预约'
                }
            ],
            activeNav:'0',
            tableData:[
                {
                    title:'建筑安装行业核心业务税务处理与纳税筹划...',
                    place:'北京',
                    date:'2021-11-26  08:50:00',
                    isMark:false
                },
                {
                    title:'建筑安装行业核心业务税务处理与纳税筹划...',
                    place:'北京',
                    date:'2021-11-26  08:50:00',
                    isMark:true
                },
                {
                    title:'建筑安装行业核心业务税务处理与纳税筹划...',
                    place:'北京',
                    date:'2021-11-26  08:50:00',
                    isMark:false
                }
            ],
            tipsDialog:false
        }
    },
    mounted(){
        
    },
    methods: {
        handleNav(target){
            this.activeNav=target;
        },
        handleSearch(){

        },
        viewMore(){

        },
        viewLive(){
            this.tipsDialog=true;
        },
        handleMark(){
            this.tipsDialog=false;
        },
        viewDetail(row){
            this.$router.push('/myRights/offline-course/detail');
        }
    }
}
</script>

<style scoped>
.header-container{
    display:flex;
    justify-content: space-between;
    margin-top:16px;
}
.nav-wrapper{
    display: flex;
}
.nav-item-active{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    height:36px;
    line-height:25px;
    margin-right:30px;
    position:relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor:pointer;
}
.nav-item{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    height:36px;
    line-height:25px;
    margin-right:30px;
    position:relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.nav-item:hover{
    cursor: pointer;
    color:#000000;
}
.nav-line-wrapper{
    width:100%;
    bottom:0px;
    left:0px;
    position:absolute;
    display: flex;
    justify-content: center;
    margin-top:6px;
}
.nav-line{
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.table-container{
    margin-top:20px;
}
.search-container{
    display:flex;
    align-items: center;
}
.page-mode-input-wrapper{
    display: flex;
    width:235px;
    position: relative;
    top:-5px;
}
.page-mode-input>>>.el-input__inner{ 
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right:0px !important;
}
.input-btn{
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.input-btn:hover{
    cursor:pointer;
    opacity:0.8;
}
.input-btn-icon{
    font-size: 13px;
}
.input-btn-label{
    margin-left:5px;
}
.month-wrapper{
    margin-left:20px;
    position:relative;
    top:-5px;
}
.month-wrapper>>>.el-date-editor.el-input,.el-date-editor.el-input__inner {
    width: 100px !important;
    cursor: pointer !important;
}
.month-wrapper>>>.el-input__inner{
    border:0px !important;
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #333333 !important;
    padding:0px !important;
    cursor: pointer !important;
}
.month-wrapper>>>.el-input__prefix{
    display:none !important;
}
.month-icon-wrapper{
    position:absolute;
    right:0px;
    top:11px;
}
.month-icon{
    color:#4F79ED;
}
.table-item-wrapper{
    display:flex;
    justify-content: space-between;
    padding-top:32px;
}
.table-content-wrapper{
    flex:1;
    display: flex;
    justify-content: space-between;
    padding-bottom:40px;
    border-bottom:solid #F0F0F0 1px;
}
.table-btn-wrapper{
    margin-top:27px;
}
.table-btn{
    width: 122px;
    height: 34px;
    background: linear-gradient(315deg, #5596F6 0%, #3777D6 49%, #1A5DC6 100%);
    border-radius: 20px;
    line-height:34px;
    text-align:center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.table-btn:hover{
    cursor: pointer;
    opacity:0.8;
}
.table-title-wrapper{
    display:flex;
}
.table-title{
    width: 396px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}
.table-brief-wrapper{
    margin-top:16px;
    display:flex;
}
.table-brief-title{
    width:108px;
    height:28px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    position: absolute;
    left:0px;
    top:0px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.table-brief{
    height:28px;
    display:flex;
    justify-content: center;
    align-items: center;
}
.table-brief-item{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-right:30px;
}
.view-more-btn{
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin:0 auto;
    margin-top:50px;
    margin-bottom:20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.view-more-btn:hover{
    cursor: pointer;
    background: #F69264;
    color:#fff;
}
.team-manage-container>>>.el-dialog__body{ 
    padding: 0px !important;
}
.team-manage-container>>>.el-dialog__header{
    padding: 0px !important;
}
.dialog-header{
    width:100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}
.dialog-content{
    padding:46px 77px 60px 77px;
}
.dialog-info{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}
.dialog-btn{
    width: 72px;
    height: 36px;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display:flex;
    justify-content: center;
    align-items: center;
    padding:0px 18px 0px 18px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.dialog-btn:hover{
    cursor:pointer;
    opacity:0.8;
}
.table-progress-wrapper{
    margin-left:20px;
    width:324px;
    position:relative;
    top:11px;
}
.dialog-btn-wrapper{
    display: flex;
    margin-top:50px;
    justify-content: center;
}
</style>


